import React from "react"
import Swiper from "react-id-swiper"
import 'swiper/swiper.scss'
import 'animate.css'
import { inject, observer } from 'mobx-react';
import CanvasDraw from "react-canvas-draw";
import "./../../../assets/scss/pages/app-chat.scss"

@observer
class Slide extends React.Component {

  static getDerivedStateFromProps(props, state) {
    if (props.slide){
      if (props.slide.content !== state.imgUrl) {
        return {
          imgUrl: props.slide.content,
          clearCanvas: true,
          brushColor: props.brushColor
        }
      }
    }
    return null;
  }

  state = {
    imgUrl: this.props.slide.content ? this.props.slide.content : null,
    clearCanvas: false,
    brushColor: this.props.brushColor ? this.props.brushColor : "#f50f02",
    height: 400,
    width: 700,
    initialLoad: true
  }

  updateDimensions = async () => {
    const asp_ratio = this.state.height/this.state.width;
    let new_width = document.getElementsByClassName('slide')[0].clientWidth > 700 
                      ? 700 : document.getElementsByClassName('slide')[0].clientWidth;
    let new_height = document.getElementsByClassName('slide')[0].clientWidth*asp_ratio > 400 
                      ? 400 : document.getElementsByClassName('slide')[0].clientWidth*asp_ratio
    
    let w_ratio = (new_width/this.state.width)
    let h_ratio = (new_height/this.state.height) 

    if (w_ratio !== 1 || h_ratio !== 1) {
      let data = JSON.parse(this.saveableCanvas.getSaveData());
      if (data.lines.length > 0) {
        let index;
        for (index in data.lines) {
          let point;
          for (point of data.lines[index].points){
             point.x *= w_ratio
             point.y *= h_ratio
          }
        }
        this.clearScreen()
        this.saveableCanvas.loadSaveData(JSON.stringify(data), true)
      }
    }

    this.setState({
      height: new_height,
      width: new_width
    })
  };

  componentDidMount = () => {
    window.addEventListener("resize", this.updateDimensions);    
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  onChange = () => {
    if (this.saveableCanvas) {
      let data = this.saveableCanvas.getSaveData();
      this.props.updateCanvas(data);
    }
  }

  clearScreen = () => {
    this.setState({ clearCanvas: false })
    if (this.saveableCanvas) {
      this.saveableCanvas.clear();
      this.onChange();
    }
  }

  undo = () => {
    if (this.saveableCanvas) {
      this.saveableCanvas.undo();
    }
  }

  changeDimensions = () => {   // Put Try/Catch to remove error as a quick fix. Need to be checked. @Akash
    try {
      if (document.getElementsByClassName('img-fluid')[0]) {
            const asp_ratio = this.state.height/this.state.width;
            let new_width = document.getElementsByClassName('slide')[0].clientWidth > 700 ? 700 : document.getElementsByClassName('slide')[0].clientWidth;
            let new_height = new_width*asp_ratio
            if (new_height > 30) {
              this.setState({
                width: new_width,
                height: new_height,
                initialLoad: false
              })
            }
            this.onChange();
          } 
    } catch {
      return
    }
  }

  render() {
    const { slide } = this.props
    const device = this.props.device == null ? '' : this.props.device;
    const disableCanvas = this.props.status == "STARTED" ? false : true;    
    if (this.state.clearCanvas) {
      {this.clearScreen()}
    }
    if (this.state.width == 700 && this.state.height == 400 && this.state.initialLoad == true) {
      {this.changeDimensions()}
    }
    const slideComp = slide.type === 'LINK' ? (
        <div className="slide">
            <CanvasDraw 
              disabled={disableCanvas}
              onChange={this.onChange}
              ref={canvasDraw => (this.saveableCanvas = canvasDraw)}
              loadTimeOffset={2}
              className={`img-fluid ${
                slide.animate
                ? `animated ${slide.animate}`
                  : ""
                }`}
              imgSrc={this.state.imgUrl}
              brushRadius={2}
              hideGrid={true}
              canvasWidth={this.state.width}
              canvasHeight={this.state.height}
              brushColor={this.props.brushColor}
              hideInterface={true}
              lazyRadius={2}
            />
        </div>)
      : (
        <div dangerouslySetInnerHTML={{__html: slide.content}} />
      );
    
    return <React.Fragment>
          <div className={device}>
            {slideComp}
          </div>
          </React.Fragment>
  }
}
export default Slide;
